<template>
    <div>
        <b-row>
            <b-col cols="12" lg="12">
                <app-form-textarea-input
                    label="Novedad"
                    id="novelty"
                    v-model="theNovelty.novelty"
                    :hasError="$v.theNovelty.novelty.$error"
                    errorMessage="Debe escribir alguna novedad"
                    @input="$v.theNovelty.novelty.$touch()"
                />
            </b-col>
        </b-row>
    </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
import * as mutations from '../../../../../store/commitTypes'
import { required } from 'vuelidate/lib/validators'

export default {
    props: {
        serviceId: {
            required: true,
        },
        onSave: {
            type: Function,
        },
    },
    data() {
        return {
            theNovelty: {
                novelty: '',
            },
        }
    },
    validations: {
        theNovelty: {
            novelty: { required },
        },
    },
    methods: {
        async saveNovelty() {
            this.$v.$touch()
            if (this.$v.$invalid) {
                toastr.error('Debe ingresar una novedad')
                return false
            }

            const { data } = await repo.post('bodyguard-services/novelty', {
                ...this.theNovelty,
                serviceId: this.serviceId,
            })
            if (data.status) {
                this.$emit('success', data)
                this.theNovelty.novelty = ''
            } else {
                toastr.error(data.msg)
            }
        },
        cleanFields() {
            Object.keys(this.theNovelty).map(key => (this.theNovelty[key] = ''))
            this.$nextTick(() => {
                this.$v.$reset()
            })
        },
    },
    created() {
        this.$bus.$on('service-novelty-form.clean', this.cleanFields)
    },
}
</script>
